export default __webpack_public_path__ + "static/media/question.ed9641bb.png";